export default "__VITE_ASSET__C2J1Bxi1__"